<template>
  <div class="room dehumidifier-small" v-loading="loadingData">
    <div class="device-block-multi">
      <SinglePieHistogramWrap
        class="device-block-multi-item"
        :opts="singlePieHistogramWrapOptsLeft1"
        :series="singlePieHistogramWrapDataLeft1"
        :class="warningFlagLeft1"
      ></SinglePieHistogramWrap>
      <SinglePieHistogramWrap
        class="device-block-multi-item"
        :opts="singlePieHistogramWrapOptsLeft2"
        :series="singlePieHistogramWrapDataLeft2"
        :class="warningFlagLeft2"
      ></SinglePieHistogramWrap>
      <SinglePieHistogramWrap
        class="device-block-multi-item"
        :opts="singlePieHistogramWrapOptsRight1"
        :series="singlePieHistogramWrapDataRight1"
        :class="warningFlagRight1"
      ></SinglePieHistogramWrap>
      <SinglePieHistogramWrap
        class="device-block-multi-item"
        :opts="singlePieHistogramWrapOptsRight2"
        :series="singlePieHistogramWrapDataRight2"
        :class="warningFlagRight2"
      ></SinglePieHistogramWrap>
    </div>

    <div class="device-block-line">
      <div class="device-block-line-item">
        <div class="device-block-line-item-top">
          <div class="device-block-line-item-half">
            <SwitchStatus class="switch-item" :title="switchTitleLeft1" :series="switchDataLeft1"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleLeft2" :series="switchDataLeft2"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleLeft3" :series="switchDataLeft3"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleLeft4" :series="switchDataLeft4"></SwitchStatus>
          </div>
          <div class="device-block-line-item-half">
            <SwitchStatus class="switch-item" :title="switchTitleLeft5" :series="switchDataLeft5"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleLeft6" :series="switchDataLeft6"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleLeft7" :series="switchDataLeft7"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleLeft8" :series="switchDataLeft8"></SwitchStatus>
          </div>
        </div>
        <RunningTimeBig
          class="device-block-time"
          :title="runningTimeTitleLeft"
          :series="runningTimeDataLeft"
        ></RunningTimeBig>
      </div>

      <div class="device-block-line-item">
        <div class="device-block-line-item-top">
          <div class="device-block-line-item-half">
            <SwitchStatus class="switch-item" :title="switchTitleRight1" :series="switchDataRight1"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleRight2" :series="switchDataRight2"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleRight3" :series="switchDataRight3"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleRight4" :series="switchDataRight4"></SwitchStatus>
          </div>
          <div class="device-block-line-item-half">
            <SwitchStatus class="switch-item" :title="switchTitleRight5" :series="switchDataRight5"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleRight6" :series="switchDataRight6"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleRight7" :series="switchDataRight7"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleRight8" :series="switchDataRight8"></SwitchStatus>
          </div>
        </div>
        <RunningTimeBig
          class="device-block-time"
          :title="runningTimeTitleRight"
          :series="runningTimeDataRight"
        ></RunningTimeBig>
      </div>

      <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    </div>
  </div>
</template>

<script>
import configJson from './config/dehumidifierBigConfig.json';

export default {
  name: 'dehumidifierBig',
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,
      stationId: '',
      warningFlagLeft1: '',
      warningFlagLeft2: '',
      warningFlagRight1: '',
      warningFlagRight2: '',
      deviceList: [],
      bridgeSegmentName: '',
      deviceLeftNameA: '',
      deviceLeftNameB: '',
      deviceLeftNameC: '',
      deviceRightNameA: '',
      deviceRightNameB: '',
      deviceRightNameC: '',
      singlePieHistogramWrapDataLeft1: null,
      singlePieHistogramWrapDataLeft2: null,
      singlePieHistogramWrapDataRight1: null,
      singlePieHistogramWrapDataRight2: null,
      switchDataLeft1: null,
      switchDataLeft2: null,
      switchDataLeft3: null,
      switchDataLeft4: null,
      switchDataLeft5: null,
      switchDataLeft6: null,
      switchDataLeft7: null,
      switchDataLeft8: null,
      switchDataRight1: null,
      switchDataRight2: null,
      switchDataRight3: null,
      switchDataRight4: null,
      switchDataRight5: null,
      switchDataRight6: null,
      switchDataRight7: null,
      switchDataRight8: null,
      runningTimeDataLeft: null,
      runningTimeDataRight: null
    };
  },
  computed: {
    singlePieHistogramWrapOptsLeft1: function() {
      return {
        title: this.bridgeSegmentName + ' '+this.deviceLeftNameA + ' 温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      };
    },
    singlePieHistogramWrapOptsLeft2: function() {
      return {
        title: this.bridgeSegmentName  + ' '+ this.deviceLeftNameB + ' 温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      };
    },
    singlePieHistogramWrapOptsRight1: function() {
      return {
        title: this.bridgeSegmentName  + ' '+ this.deviceRightNameA + ' 温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      };
    },
    singlePieHistogramWrapOptsRight2: function() {
      return {
        title: this.bridgeSegmentName  + ' '+ this.deviceRightNameB + ' 温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      };
    },
    switchTitleLeft1: function() {
      return this.deviceLeftNameA + '一级除湿';
    },
    switchTitleLeft2: function() {
      return this.deviceLeftNameA + '运行';
    },
    switchTitleLeft3: function() {
      return this.deviceLeftNameB + '运行';
    },
    switchTitleLeft4: function() {
      return this.deviceLeftNameC + '运行';
    },
    switchTitleLeft5: function() {
      return this.deviceLeftNameA + '二级除湿';
    },
    switchTitleLeft6: function() {
      return this.deviceLeftNameA + '故障';
    },
    switchTitleLeft7: function() {
      return this.deviceLeftNameB + '故障';
    },
    switchTitleLeft8: function() {
      return this.deviceLeftNameC + '故障';
    },
    runningTimeTitleLeft: function() {
      return this.deviceLeftNameA + '运行时间';
    },
    switchTitleRight1: function() {
      return this.deviceRightNameA + '一级除湿';
    },
    switchTitleRight2: function() {
      return this.deviceRightNameA + '运行';
    },
    switchTitleRight3: function() {
      return this.deviceRightNameB + '运行';
    },
    switchTitleRight4: function() {
      return this.deviceRightNameC + '运行';
    },
    switchTitleRight5: function() {
      return this.deviceRightNameA + '二级除湿';
    },
    switchTitleRight6: function() {
      return this.deviceRightNameA + '故障';
    },
    switchTitleRight7: function() {
      return this.deviceRightNameB + '故障';
    },
    switchTitleRight8: function() {
      return this.deviceRightNameC + '故障';
    },
    runningTimeTitleRight: function() {
      return this.deviceRightNameA + '运行时间';
    }
  },
  created() {
    this.readConfig();
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.readConfig();
      this.loadingData = true;
      this.getData();
    }
  },
  methods: {
    resetData() {
      this.warningFlagLeft = '';
      this.warningFlagRight = '';
    },
    refreshData() {
      this.loadingData = true;
      this.getData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    readConfig() {
      const routerPath = this.$route.fullPath.split('/');
      this.deviceList = configJson[routerPath[2]].deviceList;
      const deviceName = configJson[routerPath[2]].deviceName;
      this.deviceLeftNameA = deviceName.deviceLeftNameA;
      this.deviceLeftNameB = deviceName.deviceLeftNameB;
      this.deviceLeftNameC = deviceName.deviceLeftNameC;
      this.deviceRightNameA = deviceName.deviceRightNameA;
      this.deviceRightNameB = deviceName.deviceRightNameB;
      this.deviceRightNameC = deviceName.deviceRightNameC;
      this.stationId = configJson[routerPath[2]].stationId;
      this.bridgeSegmentName = configJson[routerPath[2]].bridgeSegmentName;
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find(el => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || '';
    },
    getCurrentData(stationId) {
      return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
    },
    getData() {
      this.getCurrentData(this.stationId).then(res => {
        setTimeout(() => {
          this.loadingData = false;
        }, 500); 

        const currentData = res.data;

        this.setPieHistogramDataAndError(
          currentData,
          'singlePieHistogramWrapDataLeft1',
          this.deviceLeftNameA + '温度',
          this.deviceLeftNameA + '湿度',
          'warningFlagLeft1'
        );
        this.setPieHistogramDataAndError(
          currentData,
          'singlePieHistogramWrapDataLeft2',
          this.deviceLeftNameB + '温度',
          this.deviceLeftNameB + '湿度',
          'warningFlagLeft1'
        );
        this.setPieHistogramDataAndError(
          currentData,
          'singlePieHistogramWrapDataRight1',
          this.deviceRightNameA + '温度',
          this.deviceRightNameA + '湿度',
          'warningFlagRight1'
        );
        this.setPieHistogramDataAndError(
          currentData,
          'singlePieHistogramWrapDataRight2',
          this.deviceRightNameB + '温度',
          this.deviceRightNameB + '湿度',
          'warningFlagRight1'
        );

        const switchIdLeft1 = this.findDeviceId(
          this.deviceLeftNameA + '一级除湿'
        );
        const switchIdLeft2 = this.findDeviceId(this.deviceLeftNameA + '运行');
        const switchIdLeft3 = this.findDeviceId(this.deviceLeftNameB + '运行');
        const switchIdLeft4 = this.findDeviceId(this.deviceLeftNameC + '运行');
        const switchIdLeft5 = this.findDeviceId(
          this.deviceLeftNameA + '二级除湿'
        );
        const switchIdLeft6 = this.findDeviceId(this.deviceLeftNameA + '故障');
        const switchIdLeft7 = this.findDeviceId(this.deviceLeftNameB + '故障');
        const switchIdLeft8 = this.findDeviceId(this.deviceLeftNameC + '故障');
        this.switchDataLeft1 = {
          data: currentData[switchIdLeft1].value,
          isError: currentData[switchIdLeft1].errorLevel
        };
        this.switchDataLeft2 = {
          data: currentData[switchIdLeft2].value,
          isError: currentData[switchIdLeft2].errorLevel
        };
        this.switchDataLeft3 = {
          data: currentData[switchIdLeft3].value,
          isError: currentData[switchIdLeft3].errorLevel
        };
        this.switchDataLeft4 = {
          data: currentData[switchIdLeft4].value,
          isError: currentData[switchIdLeft4].errorLevel
        };
        this.switchDataLeft5 = {
          data: currentData[switchIdLeft5].value,
          isError: currentData[switchIdLeft5].errorLevel
        };
        this.switchDataLeft6 = {
          data: currentData[switchIdLeft6].value,
          isError: currentData[switchIdLeft6].errorLevel,
          isZh: true
        };
        this.switchDataLeft7 = {
          data: currentData[switchIdLeft7].value,
          isError: currentData[switchIdLeft7].errorLevel,
          isZh: true
        };
        this.switchDataLeft8 = {
          data: currentData[switchIdLeft8].value,
          isError: currentData[switchIdLeft8].errorLevel,
          isZh: true
        };

        const switchIdRight1 = this.findDeviceId(
          this.deviceRightNameA + '一级除湿'
        );
        const switchIdRight2 = this.findDeviceId(
          this.deviceRightNameA + '运行'
        );
        const switchIdRight3 = this.findDeviceId(
          this.deviceRightNameB + '运行'
        );
        const switchIdRight4 = this.findDeviceId(
          this.deviceRightNameC + '运行'
        );
        const switchIdRight5 = this.findDeviceId(
          this.deviceRightNameA + '二级除湿'
        );
        const switchIdRight6 = this.findDeviceId(
          this.deviceRightNameA + '故障'
        );
        const switchIdRight7 = this.findDeviceId(
          this.deviceRightNameB + '故障'
        );
        const switchIdRight8 = this.findDeviceId(
          this.deviceRightNameC + '故障'
        );
        this.switchDataRight1 = {
          data: currentData[switchIdRight1].value,
          isError: currentData[switchIdRight1].errorLevel
        };
        this.switchDataRight2 = {
          data: currentData[switchIdRight2].value,
          isError: currentData[switchIdRight2].errorLevel
        };
        this.switchDataRight3 = {
          data: currentData[switchIdRight3].value,
          isError: currentData[switchIdRight3].errorLevel
        };
        this.switchDataRight4 = {
          data: currentData[switchIdRight4].value,
          isError: currentData[switchIdRight4].errorLevel
        };
        this.switchDataRight5 = {
          data: currentData[switchIdRight5].value,
          isError: currentData[switchIdRight5].errorLevel
        };
        this.switchDataRight6 = {
          data: currentData[switchIdRight6].value,
          isError: currentData[switchIdRight6].errorLevel,
          isZh: true
        };
        this.switchDataRight7 = {
          data: currentData[switchIdRight7].value,
          isError: currentData[switchIdRight7].errorLevel,
          isZh: true
        };
        this.switchDataRight8 = {
          data: currentData[switchIdRight8].value,
          isError: currentData[switchIdRight8].errorLevel,
          isZh: true
        };

        const runningTimeIdLeft = this.findDeviceId(
          this.deviceLeftNameA + '运行时间'
        );
        this.runningTimeDataLeft = currentData[runningTimeIdLeft].value;

        const runningTimeIdRight = this.findDeviceId(
          this.deviceRightNameA + '运行时间'
        );
        this.runningTimeDataRight = currentData[runningTimeIdRight].value;
      });
    },
    setPieHistogramDataAndError(
      currentData,
      echartSeriesDataName,
      temperatureName,
      humidityName,
      warningFlagName
    ) {
      const temperatureId = this.findDeviceId(temperatureName);
      const humidityId = this.findDeviceId(humidityName);
      this[echartSeriesDataName] = {
        data1: currentData[temperatureId].value,
        data2: currentData[humidityId].value
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(
        currentData[temperatureId].errorLevel,
        this[warningFlagName]
      );
      errorLevel = this.getErrorLevelFromMultipleDevice(
        currentData[humidityId].errorLevel,
        this[warningFlagName]
      );
      this[warningFlagName] = errorLevel;
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === 'Error') {
        return 'Error';
      } else if (currentErrorLevel === 'Warning') {
        if (newErrorLevel === 'Error') {
          return 'Error';
        } else {
          return 'Warning';
        }
      } else {
        return newErrorLevel;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dehumidifier-small {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;

  .device-block-multi {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block-multi-item {
      width: calc((100% / 4) - 10px);
      background-color: rgba(255, 255, 255, 0.6);
    }
  }

  .device-block-line {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block-line-item {
      width: calc(50% - 10px);
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      flex-direction: column;
      align-items: stretch;

      .device-block-line-item-top {
        display: flex;
        justify-content: space-between;
        height: 184px;
        width: 100%;
      }

      .device-block-line-item-half {
        display: flex;
        height: 100%;
        width: calc(50% - 7px);
        flex-direction: column;
        justify-content: space-between;
      }

      .switch-item {
        height: 38px;
        width: 100%;
        box-sizing: border-box;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }

      .device-block-time {
        height: calc(100% - 197px);
        width: 100%;
        box-sizing: border-box;
      }
    }
  }
}
</style>
